import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIHoverActionController} from './UIHoverActionController'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {TileCornerBuildingType} from '@colonist/game-states'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {GameStateEnums} from '../../../../../shared/GameEnums'

export class UIKnightPlacementHoverActionController extends UIHoverActionController {
    private readonly knightPlayerValidator: MechanicValidatorKnightPlayer

    constructor(uiGameManager: UIGameManager, knightPlayerValidator: MechanicValidatorKnightPlayer) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.Knight)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmPlaceKnightSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.knightPlayerValidator = knightPlayerValidator
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)

        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated: this.updateState(); break
            default: break
        }
    }

    getBankActionAmount(locationCornerIndex: number): number | undefined {
        return this.knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(1)
    }

    protected updateState() {
        const useResources = true
        const action = this.knightPlayerValidator.canPlayerPlaceNewKnight(useResources)
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction)
    }

    getTexture(locationCornerIndex: number): PIXI.Texture {
        const knightTexture = TileCornerBuildingType.KnightInactiveLevel1
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture)
    }
}
